<!-- 系统映射关系 -->
<template>
  <div class="mappingData">
    <vxe-table
      border
      resizable
      show-overflow
      :span-method="rowspanMethod"
      :data="tableData"
      size="mini"
      ref="dataMappingTable"
      auto-resize
    >
      <vxe-table-column field="onedataType" title="中台类别" min-width="150"></vxe-table-column>
      <vxe-table-column
        field="onedataTypeValue"
        title="中台类别值"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column field="mapSystemName" title="映射系统" min-width="150"></vxe-table-column>
      <vxe-table-column field="mapTypeName" title="映射类别" min-width="150"></vxe-table-column>
      <vxe-table-column field="mapTypeValue" title="映射类别值" min-width="150"></vxe-table-column>
    </vxe-table>
    <vxe-table
      border
      resizable
      show-overflow
      :data="callLogsDatalist"
      size="mini"
      ref="dataMappingTable"
      auto-resize
      v-if="isEdit"
      style="margin-top: 20px"
    >
      <vxe-table-column type="seq" title="序号" min-width="150"></vxe-table-column>
      <vxe-table-column field="gmtCreate" title="操作时间" min-width="150"></vxe-table-column>
      <vxe-table-column field="status" title="状态" min-width="150">
        <template v-slot="{ row }">
          {{ row.status == 0 ? '成功' : '失败' }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="errorReason" title="失败原因" min-width="150"></vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import XEUtils from 'xe-utils';
  export default {
    name: 'mappingData',
    props: ['dataMapping', 'callLogsData', 'isEdit'],
    data() {
      return {
        tableData: [],
        callLogsDatalist: [],
        mapTypeList: [
          { value: 'MDG-CUSTOM-CODE', label: 'MDG客户编码' },
          { value: 'MDG-VENDOR-CODE', label: 'MDG供应商编码' },
          { value: 'MDG-PARTNER-CODE', label: 'MDG合作伙伴编码' },
          { value: 'SAP-CUSTOM-CODE', label: 'SAP客户编码' },
          { value: 'SAP-VENDOR-CODE', label: 'SAP供应商编码' },
          { value: 'SAP-PARTNER-CODE', label: 'SAP合作伙伴编码' },
        ],
      };
    },
    watch: {
      dataMapping(val) {
        this.tableData = val;
        this.tableData.map((item) => {
          item['mapTypeName'] = this.mapTypeList.find((it) => it.value == item.mapType).label;
        });
      },
      callLogsData(val) {
        this.callLogsDatalist = val;
      },
    },
    methods: {
      // 通用行合并函数（将相同多列数据合并为一行）
      rowspanMethod({ row, $rowIndex, column, data }) {
        const fields = ['onedataType', 'onedataTypeValue'];
        const cellValue = XEUtils.get(row, column.property);
        if (cellValue && fields.includes(column.property)) {
          const prevRow = data[$rowIndex - 1];
          let nextRow = data[$rowIndex + 1];
          if (prevRow && XEUtils.get(prevRow, column.property) === cellValue) {
            return { rowspan: 0, colspan: 0 };
          } else {
            let countRowspan = 1;
            while (nextRow && XEUtils.get(nextRow, column.property) === cellValue) {
              nextRow = data[++countRowspan + $rowIndex];
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 };
            }
          }
        }
      },
    },
  };
</script>

<style scoped></style>
